import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "premium-badge"
}
const _hoisted_2 = { class: "specialist-header" }
const _hoisted_3 = { class: "avatar" }
const _hoisted_4 = { class: "specialist-info" }
const _hoisted_5 = { class: "specialist-name" }
const _hoisted_6 = {
  key: 0,
  class: "specialist-categories"
}
const _hoisted_7 = { class: "main-category" }
const _hoisted_8 = {
  key: 0,
  class: "sub-category"
}
const _hoisted_9 = {
  key: 1,
  class: "specialist-location"
}
const _hoisted_10 = {
  key: 2,
  class: "specialist-rating"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "rating-text" }
const _hoisted_13 = {
  key: 1,
  class: "specialist-description"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "specialist-actions" }


export default {
  __name: 'SingleSpecialist',
  props: {
    item: {
        required: true,
        type: Object
    }
},
  setup(__props) {



const renderStars = (rating) => {
    if (!rating || rating === 0) return '';

    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    let stars = '';
    for (let i = 0; i < fullStars; i++) {
        stars += '<i class="pi pi-star-fill" style="color: #f7b500;"></i>';
    }
    if (hasHalfStar) {
        stars += '<i class="pi pi-star" style="color: #f7b500;"></i>';
    }
    for (let i = 0; i < emptyStars; i++) {
        stars += '<i class="pi pi-star" style="color: #ddd;"></i>';
    }

    return stars;
};



const getLocationText = (localization) => {
    if (!localization) return '';

    const parts = [];
    if (localization.city) parts.push(localization.city);
    if (localization.street) parts.push(localization.street);

    return parts.join(', ');
};

return (_ctx, _cache) => {
  const _component_Image = _resolveComponent("Image")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["specialist-item", { 'premium': __props.item.is_pro }])
  }, [
    (__props.item.is_pro)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "pi pi-star-fill" }, null, -1),
          _createElementVNode("span", null, "Premium", -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Image, {
          width: "80",
          src: __props.item.logo_path || '/images/default-avatar.png',
          class: "avatar-image",
          alt: __props.item.full_name
        }, null, 8, ["src", "alt"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(__props.item.display_name), 1),
        (__props.item.category_str)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "pi pi-tag" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(__props.item.category_str), 1)
              ]),
              (__props.item.sub_category_str)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "pi pi-tag" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(__props.item.sub_category_str), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (__props.item.localization && __props.item.localization.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "pi pi-map-marker" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(getLocationText(__props.item.localization)), 1)
            ]))
          : _createCommentVNode("", true),
        (__props.item.opinion_average > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "stars",
                innerHTML: renderStars(__props.item.opinion_average)
              }, null, 8, _hoisted_11),
              _createElementVNode("span", _hoisted_12, _toDisplayString(__props.item.opinion_average) + " (" + _toDisplayString(__props.item.total_opinions || 0) + " opinii)", 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (__props.item.description && __props.item.description !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("p", {
            innerHTML: __props.item.description
          }, null, 8, _hoisted_14)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_Button, {
        label: "Zobacz profil",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$router.push({name: 'Specialist', params: {id: __props.item.id}}))),
        class: "view-profile-btn"
      })
    ])
  ], 2))
}
}

}